/* eslint-disable react/jsx-pascal-case */
import React from "react";
import PropTypes from "prop-types";
import Check from "@material-ui/icons/Check";
import { CircularProgress, withStyles } from "@material-ui/core";

import BSL_Button from "./BSL_Button";

const styles = (theme) => ({
    button: {
        margin: theme.spacing.unit,
    },
});

const BSL_LoadingButton = (props) => {
    const { classes, loading, done, ...other } = props;

    if (done) {
        return (
            <BSL_Button className={classes.button} {...other} disabled>
                <Check />
            </BSL_Button>
        );
    } else if (loading) {
        return (
            <BSL_Button className={classes.button} {...other}>
                <CircularProgress style={{ color: "white" }} size={"1.5rem"} />
            </BSL_Button>
        );
    } else {
        return <BSL_Button className={classes.button} {...other} />;
    }
};

BSL_LoadingButton.defaultProps = {
    loading: false,
    done: false,
};

BSL_LoadingButton.propTypes = {
    classes: PropTypes.object.isRequired,
    loading: PropTypes.bool,
    done: PropTypes.bool,
};

export default withStyles(styles)(BSL_LoadingButton);
